export enum ChartTypeEnum {
  BAR = 'bar',
  LINE = 'line',
  DOUGHNUT = 'doughnut',
  PIE = 'pie',
  PROGRESS_ARC = 'progress-arc',
  RADAR = 'radar',
  POLAR_AREA = 'polarArea',
  BUBBLE = 'bubble',
  SCATTER = 'scatter',
}

export enum ChartDataContext {
  TOTAL_SPENDING = 'total-spending',
  FORM_ID = 'form-id',
}

export enum ChartDateRange {
  WEEK = 'week',
  MONTH_DAYS = 'month-days',
  MONTH_WEEKS = 'month-week',
  YEAR = 'year',
}

export enum ChartLegendPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  CENTER = 'center',
}
